import { Mui, Image } from '@onedesign/ui';
import background from '/static/images/backgroundLogin.svg';

const { Box, styled } = Mui;

// page
export const StyledLogin = styled(Box)({
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  backgroundImage: `url(${background})`,
  backgroundSize: 'cover',
  '@media(max-width: 1024px)': {
    padding: '20px 20px 20px 20px',
    height: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    position: 'initial',
  },
});

// Change language
export const StyledChangeLanguageBox = styled(Box)({
  position: 'absolute',
  right: '1.5rem',
  top: '1.5rem',
  '@media(max-width: 1024px)': {
    position: 'initial',
    marginLeft: 'auto',
    clear: 'right',
  },
});

// login modal
export const StyledLoginBox = styled(Box)(() => ({
  display: 'flex',
  width: '60%',
  maxWidth: '900px',
  position: 'relative',
  '@media(max-width: 1024px)': {
    width: '100%',
    height: 'auto',
    minHeight: '100vh',
    flexDirection: 'column',
    padding: '5px',
  },
}));

export const StyledLoginIntro = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40%',
  maxWidth: '400px',
  padding: '0 10px',
  backgroundColor: theme.palette.primary.lighter,
  borderRadius: '20px 0 0 20px',
  '@media(max-width: 1024px)': {
    width: '100%',
    maxWidth: '100%',
    borderRadius: '20px 20px 0 0',
    // 手動撐出來的空間，模擬「返回按鈕把 Logo 推下去」的效果。
    // 返回按鈕（StyledBackButton, pages/Login/Login.style.ts）在手機版是 position:absolute，
    // 不會真的佔位、也不會推擠 Logo，所以這裡用固定 paddingTop 手動兜出視覺上一樣的間距：
    // 按鈕 top(24px) + 按鈕高度(30px) + 設計稿間距(24px) = 78px。
    // 之後如果調整了按鈕的 top/高度，這個值也要跟著手動重算，兩者沒有真正綁定。
    paddingTop: '78px',
    backgroundColor: theme.palette.grey[100],
    flexDirection: 'column',
    position: 'relative',
  },
}));

// logo
export const StyledLoginIntroLogoContainer = styled('div')({});
export const StyledLoginIntroLogo = styled(Image)({
  height: '104px',
  '@media(max-width: 1024px)': {
    height: '70px',
    width: 'auto',
  },
});
